<template>
  <div class="c-project-card u-color--one">
    <div v-if="result.image"
      class="c-project-card__img"
      v-bind:style="{backgroundImage: 'url(' + result.image.url +')'}"
    ></div>
    <div class="c-project-card__content">
      <span class="c-project-card__ribbon u-color__ribbon" v-if="result.type">{{result.type}}</span>
      <h3 class="c-project-card__title u-color__title">
        {{result.title}}
      </h3>
      <div class="c-project-card__info">
        <p
          class="c-project-card__location"
          v-if="result.location"
        >{{result.location.name}}</p>
        <span class="c-project-card__location-divider" v-if="result.publicationDate"></span>
        <time
          v-bind:datetime="result.publicationDate"
          class="c-project-card__date"
          v-if="result.publicationDate"
        >{{result.publicationDate}}</time>
      </div>
      <p class="c-project-card__summary" v-if="result.body">{{result.body}}</p>
      <a class="c-button c-button--brand"
        v-bind:href="result.url" 
        v-if="result.url"
        >View {{result.type}} Details</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "project-results-card-two",
  props: {
    result: {
      type: Object,
      required: true
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/components/geneco/community-search-results/projectResultsCardTwo.vue